import { requestConfig } from "../config.js";

/**
 * Отправить запрос на получение SMS-кода для подтверждения номере телефона
 *
 * @param {String} phoneNumber
 */
export async function apiFetchCodePhoneNumber(phoneNumber) {
  await requestConfig.post("/api/v0/change_phone/phone_confirm/", {
    phone: phoneNumber,
  });
}

/**
 * Подтвердить введенный номер телефона
 *
 * @param {String} phoneNumber
 * @param {Number} uniqueCode
 */
export async function apiConfirmPhoneNumber(phoneNumber, uniqueCode) {
  const response = await requestConfig.post("/api/v0/change_phone/check_sms/", {
    phone: phoneNumber,
    sms_code: uniqueCode,
  });

  if (response?.data.status_id === 519) {
    throw new Error("Неверный код");
  }
}
